/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_mobile_analytics_app_id": "3aef7084e81440c89503f6994f8125bd",
    "aws_mobile_analytics_app_region": "us-east-1",
    "aws_pinpoint_app_id": "3aef7084e81440c89503f6994f8125bd",
    "aws_pinpoint_region": "us-east-1",
    "Analytics": {
        "AWSPinpoint": {
            "appId": "3aef7084e81440c89503f6994f8125bd",
            "region": "us-east-1"
        }
    },
    "aws_cognito_identity_pool_id": "us-east-1:00c696b4-d34b-492d-961d-a283209079a0",
    "aws_cognito_region": "us-east-1",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": []
};


export default awsmobile;
